export const convertToIST = (date) => {

    if (!date) return "----";

    const dateString = date.split('T')[0]; // Get only the date part
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;


}